import type {ImmersivePlugin} from '@github-ui/copilot-chat/plugin'
import {TASKS_IN_CHAT_COMPONENT_ID, TASKS_PLUGIN_ID, TASKS_PLUGIN_NAME} from './utils/constants'
import {TaskChatSuspendedWrapper} from './components/task-view/TaskChat'

const TASKS_IN_CHAT_REGEX = /\/copilot\/t\/([a-zA-Z0-9-_]+)\/([^/]+)\/([a-zA-Z0-9-_]+)/
const TASKS_BY_ID_REGEX = /\/copilot\/tasks\/(?!pull\/)([a-zA-Z0-9-_]+)/

export class TasksPlugin implements ImmersivePlugin {
  id = TASKS_PLUGIN_ID

  displayName = TASKS_PLUGIN_NAME

  skipSyncRouteToThread = true

  components = [
    {
      id: TASKS_IN_CHAT_COMPONENT_ID,
      Component: TaskChatSuspendedWrapper,
      routes: [TASKS_IN_CHAT_REGEX, TASKS_BY_ID_REGEX],
    },
  ]
}
